import { BasicConfig } from '@shared/models/basic-config.interface';

export abstract class NotesConfig extends BasicConfig {
  privileges: {
    job: {
      notes: string;
      hiringManager: string;
    };
  };
}

export type NotesPrivileges = NotesConfig['privileges'];
